import {useLayoutEffect, useMemo, useState} from 'react';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {Home} from 'features/Home';
import {NotFound} from 'components/NotFound';
import {TranslatableResource} from 'features/Translations';
import {Fullscreen} from '@shopify/app-bridge/actions';
import {isShopifyMobile} from '@shopify/app-bridge/utilities';
import {appBridge} from 'packages/app-bridge';
import {withContext} from 'utilities/loaders/utilities';
import {getSerialized} from 'utilities/server-data';
import {setLoaderContext} from 'utilities/loaders/context';
import {client as apolloClient} from 'foundation/GraphQL/apollo-client';
import {ErrorFallback} from 'components/ErrorFallback/ErrorFallback';

import {loader as rootLoader} from './loader';
import {RootProviders} from './RootProviders';

const FullscreenTranslatableResource = () => {
  const abFullscreen = useMemo(() => Fullscreen.create(appBridge), []);
  const [isFullscreen, setIsFullscreen] = useState(isShopifyMobile());

  useLayoutEffect(() => {
    if (isShopifyMobile()) return;

    const unsubscribe = abFullscreen.subscribe(Fullscreen.Action.ENTER, () => {
      setIsFullscreen(true);
    });

    abFullscreen.dispatch(Fullscreen.Action.ENTER);

    return () => {
      if (isShopifyMobile()) return;
      abFullscreen.dispatch(Fullscreen.Action.EXIT);
      unsubscribe();
    };
  }, [abFullscreen]);

  return isFullscreen ? <TranslatableResource /> : null;
};

const {locale, shop} = getSerialized();

setLoaderContext('app', {
  graphQL: apolloClient,
  locale,
  shop,
});

const router = createBrowserRouter([
  {
    element: <RootProviders />,
    loader: withContext(rootLoader),
    id: 'app',
    errorElement: <ErrorFallback />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/localize/:resourceType',
        element: <FullscreenTranslatableResource />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);

function Routes() {
  return <RouterProvider router={router} />;
}

export default Routes;
